export const ICONS = new Set([
  'msg',
  'view',
  'password',
  'view_off',
  'list-otp',
  'list',
  'discover',
  'account-setting',
  'settings',
  'bug',
  'code',
  'code-circle',
  'favourite',
  'store',
  'wallet',
  'menu',
  'lock',
  'deconnexion',
  'home',
  'search',
  'cancel',
  'add-circle-half-dot',
  'database-import',
  'rotate',
  'pencil-edit',
  'delete',
  'file-paste',
  'file-validation',
  'user-group',
  'profile',
  'list-marker',
  'circle-arrow',
  'arrow-left',
  'filter',
  'remove-circle',
  'filter',
  'document-validation',
  'user-status-stroke-rounded',
  'building',
  'building-02',
  'security',
  'phone',
  'user',
  'password-lock',
  'link-square',
  'pin',
  'user-lock',
  'arrow-left-back',
  'tape-measure',
  'plus',
  'loader',
  'add-circle-rounded',
  'orbit',
  'folder-view',
  'more-vertical',
  'pin-location',
  'road-wayside',
  'hold-phone',
  'more-vertical-circle',
  'logout-02',
  'square-lock-01',
  'draft-invoices',
  'issued-invoices',
  'invoices-received',
  'download-rounded',
  'sent-rounded',
  'package-rounded',
  'calendar-02',
  'user-story',
  'user-switch',
  'lock-password',
  'bitcoin-location',
  'copy',
  'delivery-box',
  'folder-02-stroke-rounded',
  'bag',
  'facture',
  'grid',
  'file-sync',
  'money-receive',
  'search-area',
  'user-account',
  'file-refund',
  'checkmark-circle',
  'unlock-2',
  'lock-2',
  'ai-phone-02-stroke-rounded',
  'building-04-stroke-rounded',
  'file-validation-stroke-rounded',
  'invoice-03-stroke-rounded',
  'money-bag-02-stroke-rounded',
  'money-receive-01-stroke-rounded',
  'qr-code-01-stroke-rounded',
  'tag-02-stroke-rounded',
  'notification-02-stroke-rounded',
  'locked-stroke-rounded',
  'setup',
  'clock',
  'money-bag-01',
  'money-exchange',
  'reset-password',
  'percent',
  'security-lock-stroke-rounded',
  'ai-setting-stroke-rounded',
  'settings-ai',
  'chart-line-data-02-stroke-rounded',
  'market-analysis-stroke-rounded',
  'user-list-stroke-rounded',
  'invoice',
  'calendar',
  'calendar-03',
  'download-circle',
  'arrow-turn',
  'arrow',
  'sorting-1-9-stroke-rounded',
  'delete-put-back',
  'keyboard-return'
]);
